import { Component, ElementRef } from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
// Third Party
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalID, ModalType, Roles } from 'src/app/shared/models/constants';
import { User } from 'src/app/shared/models/company';

// Services
import { SharedService } from 'src/app/shared/services/shared.service';
import {
  checkPasswords,
  passwordMatchValidator,
} from 'src/app/shared/functions';

@Component({
    selector: 'app-add-edit-users',
    templateUrl: './add-edit-users.component.html',
    styleUrls: ['./add-edit-users.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, NgSelectModule]
})
export class AddEditUsersComponent {
  add_edit_user_form: FormGroup;
  selected_user: User = new User();
  modal_type: string;
  roles = Object.values(Roles);
  serial_editing_blackout: string = 'white';

  duplicate_enabled_entry = true;
  duplicate_entry = true;

  // Modals
  modalRef: BsModalRef;
  modalConfig = { animated: true };

  constructor(
    protected element: ElementRef,
    private fb: FormBuilder,
    private sharedService: SharedService
  ) {
    // Initializing Form
    this.add_edit_user_form = this.fb.group(
      {
        name_first: new FormControl({ value: null, disabled: false }, [
          Validators.required,
        ]),
        name_last: new FormControl({ value: null, disabled: false }, [
          Validators.required,
        ]),
        username: new FormControl({ value: null, disabled: false }, [
          Validators.required,
        ]),
        password: new FormControl({ value: null, disabled: false }, [
          Validators.required,
        ]),
        password2: new FormControl({ value: null, disabled: false }, [
          Validators.required,
        ]),
        role: new FormControl({ value: null, disabled: false }, [
          Validators.required,
        ]),
      }
    );
  }

  ngOnInit(): void {
    if (this.modal_type === ModalType.edit) {
      this.add_edit_user_form.patchValue({
        name_first: this.selected_user.name_first,
        name_last: this.selected_user.name_last,
        username: this.selected_user.username,
        password: this.selected_user.password,
        password2: this.selected_user.password,
        role: this.selected_user.role,
      });
      if (this.sharedService.logged_in_user.role !== Roles.admin) {
        this.add_edit_user_form.controls['role'].disable();
      }
    }
  }

  closeModalClick(): void {
    this.add_edit_user_form.reset();
    this.sharedService.closeModal(ModalID.add_edit_users);
  }

  onSubmit() {
    const response = {
      form_values: this.add_edit_user_form.value,
      modal_type: this.modal_type,
    };
    this.sharedService.user_to_add_or_edit$.next(response);
    this.closeModalClick();
  }

}
